module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-chapter element-with-heading",
    attrs: {
      "epub:type": "chapter",
      "id": "chapter-3",
      "role": "doc-chapter"
    }
  }, [_c('div', {
    staticClass: "heading heading-container-single heading-size-full heading-format-full heading-alignment-flexible heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-title-is-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "element-title case-upper"
  }, [_c('span', {
    staticClass: "element-number-term"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "element-number-number"
  }, [_vm._v("THREE")])])]), _vm._v(" "), _c('h2', {
    staticClass: "element-subtitle case-upper"
  }, [_vm._v("6 APRIL 1979")])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "chapter-3-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width first-with-first-letter-i"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("“I")]), _vm._v("n actual fact,” Rebecca says at dinner that evening in the hotel (after a bottle and three-quarters of a very decent Chablis), “I don’t have a perfect life at all. And what you said earlier shows you don’t know me as well as you think.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Pamela waits for their dessert plates and cutlery to be cleared before replying. “So, tell me more.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“When you were trying to contact me in January, or maybe February, you didn’t hear back because I was depressed. I’m being serious. Depressed.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“That doesn’t sound much like you.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Perhaps not.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Pamela drains her glass, narrows her eyes, clearly hoping for elucidation.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Rebecca says that she’ll explain as best she can, although even now it doesn’t make that much sense. At the end of January, she won a business award, an industry thing, not for the first time, as it happens. And remember what the weather was like at that time? The same night she’d been presented her award, she’d arrived home but instead of going inside to make a hot drink, she remained outside.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“There’s something about the beauty of a thick late-night snow fall, isn’t there? But as I watched it, I experienced a crippling sense of helplessness. Which turned into a proper episode of depression.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“That sounds really bad,” Pamela says vaguely.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Yes, Rebecca replies, the next day she couldn’t get out of bed until midday, and then when she did, she walked compulsively to a bridge overlooking a busy road. She’d obviously looked in a state as a woman with a dog had asked if she was okay and had then accompanied her off the bridge. After this episode, she saw her GP who referred her to a psychoanalyst.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“I’m very cut off from my feelings, apparently. I tend to intellectualise everything and am not developing intimate bonds with those around me.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Uh-huh,” Pamela says, nodding.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“You’re meant to disagree! In fact, I used you as an example. ‘What about Pamela?’ I said. ‘We’ve been friends since we were sixteen’.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Except we haven’t, technically.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“I glossed over the nine-year break. And by the way, an on-off fling with a married policeman is typical of relationships people with my ‘attachment patterns’ form. It’s getting rather hot in here. Do you fancy a walk?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Pamela looks hesitant.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“For Christ’s sake,” Rebecca says. “There are two of us and it’s a Friday night.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("They go as they are, without coats, noticing immediately the drop in temperature. It will be okay, Pamela says. The alcohol they’ve consumed will provide extra insulation.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Rebecca talks about her father’s funeral, how as a teenager she’d resolved not to let his death destroy her. And generally, she’d been doing pretty well. Until January.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“I suppose, because I wasn’t at the school at that time,” Pamela says, “I never really knew much about that. About your father, I mean.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“There isn’t much to know. He didn’t have a job. It became too much for him.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“He once worked for Tetley’s, didn’t he?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("An imposing three-storey mansion, with bay windows and a traverse arch above its doorway, looms on their left-hand side.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Tetley’s, yes. I must have spent two sessions talking about Tetley’s, so I’d rather not get into that right now.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“What’s it like being in therapy?” Pamela asks.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“So, everything has meaning.” They continue walking for a while without speaking. “You see, notice that silence? Silence has all sorts of meaning.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("A few moments later, Rebecca’s shoe comes off on the corner of Cheltenham Road; she sits on a bench, laughing as she puts it back on.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Even this has meaning. Me losing my shoe.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“I agree,” Pamela says. “Had you been wearing a sensible pair, it wouldn’t have happened.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Excuse me, these shoes are perfectly sensible.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“They’re too high. And you’re always in trouser suits too. You need to learn to relax, woman!”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Rebecca only half hears this last riposte. Her mind has lurched back to Josephine Whitaker losing her shoe a couple of nights before in Halifax under very different circumstances.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“I’m not saying you’re uptight, because you’re certainly not that,” Pamela continues. “But you could do with dressing down a bit. If you want to find a decent guy to commit to, that is. From what you were saying earlier, I think you do.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Is that a fact?” Rebecca pretends to sound really irritated, before realising that she "), _c('i', [_vm._v("is")]), _vm._v(" actually irritated.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“It is a fact. And you could devote more time to your social life and less to your work. And try to be less vocally opinionated.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Okay, putting that piece of advice into practice,” Rebecca says, “why don’t you just fuck off?” And they both scream with laughter.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("They are approaching Harrogate’s tall red-brick theatre. A group of youths begin singing drunkenly.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“One Yorkshire Ripper. There’s only one Yorkshire RI-PPER. There’s only one Yorkshire Ripper.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“How utterly charming,” Rebecca says, loud enough for the youths to hear.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The three youths are barring their way. Pumping their fists in the air, they’ve moved on to a different song. “He’s back! He’s back! He’s back and on the attack – ha-ha!”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Rebecca holds her ground and speaks directly to the boys. “Look, could I suggest you three roll a little further into the gutter, so we can walk past?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The tallest, wearing a stained white T-shirt, puckers his face in disgust. “What did you slags just say?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The other two stand by, awaiting his instructions.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“I know a song too,” Rebecca says, removing both shoes and holding the right one aloft, stiletto out, like a dagger.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“"), _c('i', [_vm._v("Psycho Killer – Qu’est-ce que c’est. Fa-fa-fa-fa, fa-fa-fa-fa-fa, far better")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Pamela knows this one and joins in heartily.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“"), _c('i', [_vm._v("Run, run, run, run, run, run, run away!”")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("As they sing, Rebecca moves slowly towards the boys, her eyes steely. Unnerved by the display of solidarity, the youths back off, grumbling about aggressive drunken women.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“You won’t get away so lightly next time,” Rebecca calls after them as they retreat.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("For a minute or two, neither Rebecca nor Pamela speak. The wind has picked up and both are feeling the chill. Without agreeing to do so, they’re heading back towards the hotel.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“That was very appropriate,” Pamela says. “"), _c('i', [_vm._v("Psycho Killer")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Well, I thought if they can sing about serial killers, so can I.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“You were fearless, Rebecca. That’s what I admired about you at school. It’s what made you attractive to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“It was?” Rebecca says.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Yes, absolutely. I never told you, did I? – but I had a massive crush on you.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Rebecca laughs loudly for a few seconds, but it sounds slightly strained. “Well, you learn something every day.”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3536a531","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter-003.vue
// module id = 84
// module chunks = 0